/**
 * モーダルダイアログ用のスクリプト
 **/

(function () {
  "use strict";

  let scrollPosition = 0; // スクロール位置を保存する変数
  let bodyPaddingRight = 0; // 元のパディング値を保存
  let isScrollLocked = false; // スクロールロック状態を追跡

  /* 作成したHTML内のスクリプトを実行 */
  const executeScripts = (container) => {
    Array.from(container.querySelectorAll("script")).forEach((oldScript) => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value)
      );
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  };

  /* スクロールバーの幅を取得 */
  const getScrollbarWidth = () => {
    // スクロールバーの幅を計算
    return window.innerWidth - document.documentElement.clientWidth;
  };

  /* スクロールを無効化 - 修正版 */
  const disableScroll = () => {
    // すでにロックされている場合は何もしない
    if (isScrollLocked) return;

    // 現在のスクロール位置を保存
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // HTML要素にクラスを追加
    document.documentElement.classList.add("dialog-open");

    // スタイルを適用
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";

    // スクロールバー幅の補正
    const scrollbarWidth = getScrollbarWidth();
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    isScrollLocked = true;
  };

  /* スクロールを有効化 - 修正版 */
  const enableScroll = () => {
    // ロックされていない場合は何もしない
    if (!isScrollLocked) return;

    // HTML要素からクラスを削除
    document.documentElement.classList.remove("dialog-open");

    // スタイルを元に戻す
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // スクロール位置を復元
    window.scrollTo(0, scrollPosition);

    isScrollLocked = false;
  };

  /* モーダルウィンドウ内にHTMLを作成 */
  const applyModal = async (content, modalWindow) => {
    if (modalWindow) {
      const dialogContent = modalWindow.querySelector(".d-dialog__content");
      const dialogAddContent = modalWindow.querySelector(
        ".d-dialog__add_content"
      );

      if (dialogContent) {
        // ローディングサークルを一時保存
        const loadingCircle = dialogContent.querySelector(".loading_circle");
        const hasLoadingCircle =
          loadingCircle && loadingCircle.classList.contains("loading_active");

        dialogContent.innerHTML = `${content.innerHTML}${
          dialogAddContent ? dialogAddContent.innerHTML : ""
        }`;

        // ローディングサークルがアクティブだった場合は再追加
        if (hasLoadingCircle) {
          const newLoadingCircle = modalWindow.querySelector(".loading_circle");
          if (newLoadingCircle) {
            newLoadingCircle.classList.add("loading_active");
          }
        }

        executeScripts(modalWindow);
        const customEvent = new CustomEvent("customDOMContentLoaded", {
          detail: { modalWindow },
        });
        document.dispatchEvent(customEvent);
      }
    }
  };

  /* URL取得 */
  const getContent = async (url, target, modalWindow) => {
    try {
      // ローディングサークルを表示
      const loadingCircle = modalWindow.querySelector(".loading_circle");
      if (loadingCircle) {
        loadingCircle.classList.add("loading_active");
      }

      const res = await fetch(url, {
        headers: {
          "Content-Type": "text/html; charset=utf-8",
          "X-Requested-With": "fetch",
        },
      });

      if (!res.ok) {
        throw new Error("modal dialog url response error");
      }

      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      let content =
        doc.getElementById(target) || doc.querySelector(".entry-content");

      await applyModal(content, modalWindow);

      // コンテンツが読み込まれたらローディングサークルを非表示に
      if (loadingCircle) {
        const dialogContent = modalWindow.querySelector(".d-dialog__content");
        if (dialogContent) {
          dialogContent.style.height = "auto";
        }
        loadingCircle.classList.remove("loading_active");
      }
    } catch (error) {
      console.error("URL fetch エラー:", error);
      // エラー時はページへリダイレクト
      location.href = url;
    }
  };

  const openDialog = (event) => {
    event.preventDefault();

    const buttonId = event.currentTarget.dataset.id;
    const target = event.currentTarget.dataset.target;
    const modalWindow = document.getElementById(buttonId);

    if (!modalWindow) {
      console.error("モーダルウィンドウが見つかりません: " + buttonId);
      return;
    }

    const dialogContent = modalWindow.querySelector(".d-dialog__content");
    const loadingCircle = modalWindow.querySelector(".loading_circle");

    // スクロールを無効化
    disableScroll();

    // ダイアログを表示
    modalWindow.style.display = "block";

    // コンテンツが空の場合はURLから取得
    if (
      dialogContent &&
      (dialogContent.innerHTML === "" || dialogContent.childElementCount === 0)
    ) {
      dialogContent.style.height = "200px";

      const url = event.currentTarget.href || null;
      if (url && url !== "javascript:void(0);" && url !== "#") {
        getContent(url, target, modalWindow);
      }
    }
  };

  const closeDialog = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    const buttonId = event.currentTarget.dataset.id;
    const modalWindow = document.getElementById(buttonId);
    if (modalWindow) {
      modalWindow.style.display = "none";

      // スクロールを有効化
      enableScroll();

      // ローディングサークルが表示されていたら非表示に
      const loadingCircle = modalWindow.querySelector(".loading_circle");
      if (loadingCircle) {
        loadingCircle.classList.remove("loading_active");
      }
    }
  };

  // ダイアログDOM要素をmain .parting-area .main-area直下に移動させる処理
  const moveDialogsToMainArea = () => {
    const targetContainer = document.querySelector(
      "main .parting-area .main-area"
    );
    if (!targetContainer) {
      console.error("移動先のmain .parting-area .main-areaが見つかりません");
      return;
    }

    const dialogSets = document.querySelectorAll(".d-dialog-set");
    dialogSets.forEach((dialogSet) => {
      // 既にmain .parting-area .main-area直下にある場合は処理しない
      if (dialogSet.parentNode === targetContainer) return;

      // スタイルを保存
      const computedStyle = window.getComputedStyle(dialogSet);
      const originalDisplay = computedStyle.display;

      // main .parting-area .main-area直下に移動
      targetContainer.appendChild(dialogSet);

      // 移動後もスタイルを保持
      dialogSet.style.display = originalDisplay;
    });
  };

  // 初期化
  const init = () => {
    moveDialogsToMainArea();

    // イベントリスナーをセットアップ
    document.querySelectorAll(".dialog_open").forEach((button) => {
      button.addEventListener("click", openDialog);
    });

    document.querySelectorAll(".dialog_close").forEach((button) => {
      button.addEventListener("click", closeDialog);
    });

    // Escキーでダイアログを閉じる
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        const visibleDialog = document.querySelector(
          ".d-dialog-set[style*='display: block']"
        );
        if (visibleDialog) {
          const closeBtn = visibleDialog.querySelector(".dialog_close");
          if (closeBtn) {
            closeDialog({ currentTarget: closeBtn });
          }
        }
      }
    });
  };

  // DOMContentLoadedイベントでダイアログ要素を移動
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // 動的に追加される要素のためのイベント委譲
  document.addEventListener("click", (event) => {
    if (
      event.target.closest(".dialog_open") &&
      !event.target._hasClickListener
    ) {
      const button = event.target.closest(".dialog_open");
      openDialog.call(button, {
        currentTarget: button,
        preventDefault: () => event.preventDefault(),
      });
      event.preventDefault();
    } else if (
      event.target.closest(".dialog_close") &&
      !event.target._hasClickListener
    ) {
      const button = event.target.closest(".dialog_close");
      closeDialog.call(button, { currentTarget: button });
    }
  });
})();
